import { MDCTabBarScroller, MDCTabBar } from '@material/tabs/dist/mdc.tabs';

export function initMDCTabBar(tabBar) {
	if (tabBar) {
		MDCTabBar.attachTo(tabBar);
	}
}

export function initMDCTabBars() {
	const tabBars = document.querySelectorAll('.mdc-tab-bar');
	if (tabBars && (tabBars.length > 0)) {
		tabBars.forEach((tabBar, i) => {
			initMDCTabBar(tabBar);
		});
	}
}

export function initMDCTabBarScroller(tabBarScroller) {
	if (tabBarScroller) {
		MDCTabBarScroller.attachTo(tabBarScroller);
	}
}

export function initMDCTabBarScrollers() {
	const tabBarScrollers = document.querySelectorAll('.mdc-tab-bar-scroller');
	if (tabBarScrollers && (tabBarScrollers.length > 0)) {
		tabBarScrollers.forEach((tabBarScroller, i) => {
			initMDCTabBarScroller(tabBarScroller);
		});
	}
}